import React from 'react'
import UserImage from "../assets/user.png"
import { Link, useNavigate } from 'react-router-dom'
import { FaEnvelope } from 'react-icons/fa'

const AdminCard = ({ admin }) => {

    const navigate = useNavigate()
    return (
        <div className="admin-card-container">
            <Link to={`/user/${admin._id}`}>
                <div className="admin-card-details">
                    <div className="admin-card-profile-image">
                        <img src={admin?.profilePic ? admin.profilePic.url : UserImage} alt='' />
                    </div>
                    <div className="user-profile-name">
                        <p className=''>{admin?.firstname} {admin?.lastname}</p>
                    </div>
                </div>
            </Link>
            <div className="admin-chat-btn" onClick={() => navigate(`/chats/friends/${admin._id}`, { state: { frd:admin } })}>
                <FaEnvelope /> <p>Message</p>
            </div>
        </div >
    )
}

export default AdminCard